import type { FaireProductEntity } from "../../entity_types/product";

export const p_9p4nfg8s2z: FaireProductEntity = {
  token: "p_9p4nfg8s2z",
  type: "product",
  name: "Garden of Fortune Butter Blanket",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/8230bc2eae5ba5b7ed9c6786bf4c121f39533e9dd05d7e56fc948def928ecdde.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b767081a2a4878891f09d6ddf2b708f04eeba554cc8fd3c241fc18e909eebd44.jpeg"
  ],
  priceDollars: 59.5,
  description: "Butter Blankets\n\nEverything’s better with butter.\n\n\n\nLight and compact, but oh, so soft and silky. Our Butter Blanket is perfect for throwing around your house or tucking inside your travel bag. Created from post-consumer recycled products and engineered for optimal performance, your cuddle game has never been butter.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * Available in 50\" x 60\" or 60\" x 80\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nSleep Responsibly.\n\nWith its natural silky softness, our Butter Blankets are guaranteed to be your new favorite cuddle buddy. The best part? They’re also friendly to the environment. Our blankets are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And since it’s engineered to perform for years, you’re sure to hang on to it, helping to reduce yours.\n",
  tags: [],
  msrpDollars: 119,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:39.374Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
